import { sendGeoEvent, sendAgeVerificationCompletedEvent } from '@/analytics/ga';
import { getCookie } from '@/utils/cookie';

export async function initSharedComponents() {
    await import('./shared_components');
}

export async function initPageComponent() {
    const pageId = document.body.dataset.pageId;

    switch (pageId) {
        case 'pornstar':
            await import('./pornstar');
            break;
        case 'creators_profile_page':
            await import('./creator_details');
            break;
        case 'creators':
            await import('./creators');
            break;
        case 'ai_creators':
            await import('./ai_creators');
            break;
        case 'edit_creator_account':
            await import('./edit_creator_account');
            break;
        case 'gif_page':
        case 'gif_page_detail':
        case 'gif_subcategory_page':
        case 'gif_newest_page':
            await import('./gif');
            break;
        case 'photo_detail_page':
            await import('./photos/detail');
        case 'photos_landing_page':
        case 'photos_search_page':
        case 'photos_trending_landing_page':
        case 'photos_newest_landing_page':
            await import('./photos/list');
            break;
        case 'username_selection':
            await import('./username_selection');
            break;
        case 'video_page':
            // TODO: Please remove this module after the release of the new video page.
            await import('./video');
            break;
        case 'video_page_new':
            // TODO: Rename the page ID to 'video_page' after the release of the new video page.
            await import('./video_new');
            break;
        case 'channel_page':
            await import('./channel');
            break;
        case 'channels':
            await import('./channels');
            break;
        case 'home':
            await import('./home');
            break;
        case 'trending':
        case 'new':
        case 'popular':
        case 'upcoming':
            await import('./listing_pages');
            break;
        case 'user_account_page':
            await import('./user_account');
        case 'search_page':
            await import('./search_page');
            break;
        case 'playlist_page':
            await import('./playlist_page');
            break;
    }
}

export function initAnalytics() {
    const urlParams = new URLSearchParams(window.location.search);

    // NOTE: Send GA event after successful age verification
    if (urlParams.get('age_verification') === '1') {
        sendAgeVerificationCompletedEvent();
        // NOTE: remove the age_verification query param from the url to avoid sending the event again
        urlParams.delete('age_verification');
        const newUrl = urlParams.toString()
            ? `${window.location.pathname}?${urlParams.toString()}`
            : window.location.pathname;
        window.history.replaceState({}, '', newUrl);
    }

    const countryCode = getCookie('coc');

    if (!countryCode) {
        return;
    }

    sendGeoEvent(countryCode);
}
